define((require) => {
    "use strict";

    var _                                  = require("underscore"),
        DashboardView                      = require("ui/dashboard/DashboardView"),
        EditBehavior                       = require("ui/behaviors/EditBehavior"),
        EditorEvents                       = require("shared/services/EditorEvents"),
        Lightbox                           = require("shared/ui/common/Lightbox"),
        Permissions                        = require("shared/security/Permissions"),
        Preconditions                      = require("shared/util/Preconditions"),
        ProjectAttachChannelCollectionView = require("ui/projects/publish/ProjectAttachChannelCollectionView"),
        ProjectAttachContentCollectionView = require("ui/projects/content/ProjectAttachContentCollectionView"),
        ProjectAttachImageLibraryView      = require("ui/projects/image/ProjectAttachImageLibraryView"),
        ProjectDashboardConfiguration      = require("ui/dashboard/ProjectDashboardConfiguration");

    var HEADER_TEMPLATE = _.template("<p class='pre-title'>Project</p>" +
        "<div class='project-title editable-container'>" +
        "<h1 contenteditable='<%- editable %>'' class='editable title<%if (!editable) { %> disabled<% } %>''  <%if (!editable) { %>disabled<% } %>><%- title %></h1>" +
        "</div>");

    return DashboardView.extend({

        className: DashboardView.prototype.className + " project-dashboard-view",

        templateHelpers: function() {
            var headerTemplateOptions = {
                title: this.options.project.get("name"),
                editable: Permissions.Privileges.CREATE.can()
            };

            return _.defaults({
                headerContentUnescaped: HEADER_TEMPLATE(headerTemplateOptions)
            }, DashboardView.prototype.templateHelpers);
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".editable-container",
                editFields: [{
                    input: ".title",
                    save: function(value) {
                        var project = this._project;

                        project.set("name", value);

                        return project
                            .saveLater()
                            .then(() => {
                                var eventProperties = {
                                    projectId: project.get("id"),
                                    updatedProperty: "name",
                                    updatedValue: value,
                                    triggerOrigin: "ProjectDashboard"
                                };

                                EditorEvents.trigger(EditorEvents.constants.UPDATE_PROJECT, eventProperties);
                            });
                    }
                }]
            }
        },

        viewScope: function() {
            var superViewScope = this.__super();

            return _.extend(superViewScope, {
                openAttachLightbox: function(options) {
                    var AttachView,
                        attachViewOptions = _.defaults(options || {}, {
                            projectContext: this.options.projectContext
                        }),
                        showSpinner = true;

                    switch (this._tab) {
                        case ProjectDashboardConfiguration.EXPERIENCES:
                            AttachView = ProjectAttachContentCollectionView;
                            // The ProjectAttachContentCollectionView supports lazy loading...
                            showSpinner = false;
                            break;

                        case ProjectDashboardConfiguration.IMAGES:
                            AttachView = ProjectAttachImageLibraryView;
                            break;

                        case ProjectDashboardConfiguration.PUBLISH:
                            AttachView = ProjectAttachChannelCollectionView;
                            break;

                        default:
                            // TODO Candidate for refactoring during MOS-2934.
                            Preconditions.warn("DefaultSwitchWarn - Tab '" + this._tab + "' not recognized.");
                            break;
                    }

                    var lightboxOptions = {
                        disableElementPosition: true,
                        css: {
                            top: "40px",
                            bottom: "40px",
                            left: "40px",
                            right: "40px",
                            position: "absolute"
                        },
                        // E.g.  "lightbox-project-images"
                        lightboxClassName: "lightbox-project-" + this._tab.get("slug"),
                        // Show a spinner as the rendering might be heavy (for none "lazy" collection views)
                        showSpinner: showSpinner
                    };

                    var attachView = new AttachView(attachViewOptions),
                        box = new Lightbox(attachView, lightboxOptions, this);

                    this.listenToOnce(attachView, "attached", function(assets) {
                        var currentView = this._activeRegion.currentView;

                        if (_.isFunction(currentView.onAttachAsset)) {
                            currentView.onAttachAsset(assets);
                        }
                    });

                    box.open();
                }
            });
        },

        initialize: function() {
            this.__super();

            var projectContext = this.options.projectContext;

            this._project = projectContext.project;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/projects/ProjectDashboardView.js